function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React from "react";
import Base from "../Base/Base";
import InlineGroup from "../InlineGroup/InlineGroup";
export default function ButtonGroup({
  children,
  joined,
  ...rest
}) {
  const mappedChildren = React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        joined
      });
    }

    return child;
  });
  return /*#__PURE__*/React.createElement(Base, _extends({
    space: "x6"
  }, rest, {
    Component: joined ? "div" : InlineGroup,
    className: "ax-button-group",
    textBreak: joined ? "none" : null
  }), mappedChildren);
}